import React from 'react';

const CategoryMarquee = () => {
  const categories = [
    { name: 'Beauty Creators', icon: '/assets/revamp/category-icons/Beauty Creators.png' },
    { name: 'Travel Creators', icon: '/assets/revamp/category-icons/Travel Creators.png' },
    { name: 'DIY Home Creators', icon: '/assets/revamp/category-icons/DIY Home Creators.png' },
    { name: 'Musicians', icon: '/assets/revamp/category-icons/Musicians.png' },
    { name: 'Designers', icon: '/assets/revamp/category-icons/Designers.png' },
    { name: 'Podcasters', icon: '/assets/revamp/category-icons/Podcasters.png' },
    { name: 'Photography', icon: '/assets/revamp/category-icons/Photography.png' },
    { name: 'Health & Fitness', icon: '/assets/revamp/category-icons/Health & Fitness Creators.png' },
    { name: 'Fashion Creators', icon: '/assets/revamp/category-icons/Fashion Creators.png' },
    { name: 'Food Creators', icon: '/assets/revamp/category-icons/Food Creators.png' },
  ];

  return (
    <section className="py-20 lg:py-24 bg-gradient-to-r from-purple-900 to-indigo-900 dark:from-black dark:to-indigo-950 overflow-hidden relative transition-colors duration-300">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10"></div>
      
      <div className="container mx-auto px-4 relative z-10 mb-12 text-center">
        <h2 className="text-3xl lg:text-4xl font-black text-white mb-4">If you post on Instagram, you can sell.</h2>
        <p className="text-lg text-purple-200/80">ReelTale is made for anyone turning content into business.</p>
      </div>

      <div className="flex animate-marquee space-x-6 whitespace-nowrap">
        {[...categories, ...categories].map((cat, index) => (
          <div 
            key={index} 
            className="flex-shrink-0 flex items-center bg-white/10 dark:bg-white/5 backdrop-blur-md rounded-full px-6 py-3 shadow-xl border border-white/20 transition-transform hover:scale-105 cursor-pointer min-w-max h-auto"
          >
            <img src={cat.icon} alt={cat.name} className="w-8 h-8 lg:w-12 lg:h-12 mr-4 object-contain filter drop-shadow-lg flex-shrink-0" />
            <span className="text-xl lg:text-2xl font-black text-white tracking-tight leading-none whitespace-nowrap">{cat.name}</span>
          </div>
        ))}
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          display: inline-flex;
          animation: marquee 30s linear infinite;
        }
      `}} />
    </section>
  );
};

export default CategoryMarquee;
